module.exports = __webpack_public_path__ + "img/img_9.118b7e23.jpeg";